import styled from 'styled-components';

export const DivField = styled.div`
  ::-webkit-input-placeholder {
    color: #888888;
    font-weight: 100;
    font-size: 15px;
  }
  width: 100%;
  height: 47px;
  border-radius: 10px;
  padding: 0 15px;
  border: 0.5px solid ${props => (props.errorCondition ? 'red' : '#888888')};
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000058;
  display: flex;
  flex-direction: row;
`;

export const Textfield = styled.input`
  ::-webkit-input-placeholder {
    color: #888888;
    font: normal normal normal 16px/21px Roboto;
    letter-spacing: 0px;
  }
  width: 100%;
  height: 47px;
  border-radius: 10px;
  padding: 0 15px;
  border: 1px solid ${(props) => (props.errorCondition ? "red" : "#888888")};
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 8px #00000058;

  &:disabled {
    background: #ebebeb 0% 0% no-repeat padding-box;
  }
`;

export const SignInButton = styled.button`
  font: normal normal 600 16px/12px Mangueira;
  letter-spacing: 0px;
  width: 100%;
  height: 45px;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  background-color: #000FFF;
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  overflow: hidden;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: 10px;
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }

  img {
    float: left;
    padding-left: 0.5rem;
  }

  span {
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none !important;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const EyeIcon = styled.span`
  width: 40px;
  line-height: 1.75;
  font-size: 1.5rem;
  cursor: pointer;
  text-align: center;
  z-index: 1;
  justify-self: end;
  user-select: none;
  color: #c9c9c9;
  &:hover {
    transition: 0.5s;
    color: #888888;
  }
`;

export const ErrorMessage = styled.span`
  font: normal normal 600 12px Mangueira;
  color: red;
  margin-top: 10px;
  font-weight: 200;
`;

export const ContactItem = styled.div`
  width: 100%;
  cursor: pointer;

  input {
    margin-left: 2px;
  }
  span {
    color: #888888;
    font: normal normal 600 16px Mangueira;
  }
`;

export const LoadMoreContainer = styled.div`
  width: 100%;
  text-align: center;
`;

export const LoadMore = styled.span`
  font: normal normal 600 16px/12px Mangueira;
  color: #000FFF;
  cursor: pointer;
`;

export const ContactListContainer = styled.div`
  width: 100%;
  height: 130px;
  overflow-y: scroll;
`;

export const NextButton = styled.button`
  font: normal normal 600 16px/12px Mangueira;
  letter-spacing: 0px;
  width: 100%;
  height: 45px;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  background-color: #000FFF;
  border-radius: 10px;
  color: #ffffff;
  border: 0;
  overflow: hidden;
  background: #000FFF 0% 0% no-repeat padding-box;
  box-shadow: box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: 10px;
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }

  img {
    float: right;
    padding-right: 0.5rem;
  }
  span {
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none !important;
  }
 
`;

export const ConfirmationContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 480px) {
    height: 90%;
  }
`;

export const ConfirmationIcon = styled.i`
  font-size: 55px;
  color: #4181f8;
`;

export const ConfirmationText = styled.div`
  width: 100%;
  text-align: center;

  p {
    font-weight: 200;
  }

  h6 {
    font-size: 19;
    color: #4d565c;
    margin-top: -10;
    margin-bottom: 10;
  }
`;

export const HeaderTitle = styled.p`
  color: #707070;
  font: normal normal 700 16px/12px Mangueira;
  padding-bottom: 5px;
  line-height: 22px;
`;

export const HeaderSubtitle = styled.p`
  margin-top: 10px;
  text-align: left;
  letter-spacing: 0px;
  color: #707070;
  font: normal normal 700 16px/12px Mangueira;
`;

export const Label = styled.label`
  text-align: left;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #707070;
  font: normal normal bold 18px Mangueira;
`;

export const LoginSubTitle = styled.p`
  margin-bottom: 10px;
  letter-spacing: 0px;
  font: normal normal bold 18px Mangueira;
  color: #000000;
  @media (max-width: 768px) {
    text-align: left;
  }
  @media (min-width: 1366px) and (max-width: 1366px) {
    font: normal normal bold 14px Mangueira;
  }
`;

export const PasswordCondition = styled.p`
  margin-top: 2px;
  font: normal normal bold 14px Mangueira;
  @media (max-width: 768px) {
    text-align: left;
  }
  @media (min-width: 1366px) and (max-width: 1366px) {
    margin-top: 0px;
    font: normal normal bold 13px Mangueira;
  }
`;